module.exports = __webpack_public_path__ + "static/img/AdvancedTorsoDesign3.f2176073.jpg";